export const covid = {
  ru: {
    message:
      'Требованиями на передвижение железно-дорожным транспортом в связи с Covid-19 являются обязательное ношение масок, соблюдение социальной дистанции и ограничение на вход в здание вокзала.',
    description:
      'Перевозчик применяет соответствующие меры в целях недопущения распространения коронавирусной инфекции при перевозке пассажиров в соответствии с Постановлением Главного государственного санитарного врача Республики Казахстан:',
    rules: [
      'По окончанию следования маршрута (рейса), во время стоянки проводится обработка контактных поверхностей разрешенными к использованию дезинфицирующими средствами (протирание дезинфицирующими салфетками) окон, ручек, дверей, поручней, сидений, с обязательным проветриванием салона;',
      'В вагоне необходимо обязательное ношение масок и соблюдение социальной дистанции как пассажирами, так и работниками транспорта;',
      'В вагонах в обязательном порядке установлены диспенсеры с санитайзерами для обработки рук пассажиров и работников транспорта.',
    ],
  },
  kk: {
    message:
      'Covid-19 індетіне байланысты теміржол көлігімен жүру талаптары - міндетті түрде бетперде кию, әлеуметтік қашықтықты сақтау және вокзал ғимаратына кіруге шектеулер болып табылады.',
    description:
      'Тасымалдаушы Қазақстан Республикасының Бас мемлекеттік санитарлық дәрігерінің қаулысына сәйкес жолаушыларды тасымалдау кезінде коронавирустық инфекцияның таралуын болдырмау бойынша тиісті шараларды қабылдайды:',
    rules: [
      'Маршруттың (рейстің) соңында тұрақ кезінде жанасатын беттер салонды міндетті түрде желдете отырып, терезелердің, тұтқалардың, есіктердің, орындықтардың рұқсат етілген дезинфекциялық құралдармен (дезинфекциялық майлықтармен сүрту) өңделеді;',
      'Тасымалдауда бетперде киіп, жолаушыларға да, көлік қызметкерлеріне де әлеуметтік қашықтықты сақтау қажет;',
      'Жолаушылар мен көлік қызметкерлерінің қолдарын емдеу үшін вагондарға санитарлық тазартқыштары бар диспенсерлер орнатылған.',
    ],
  },
}
